import { styled } from 'styled-components';
import config from '../config.json';
import { motion } from 'framer-motion';
import { theme } from '../styles';
import { getCommissionStatus } from '../lib';

const Banner = ({ size = 'lg' }) => {
  const status = getCommissionStatus();
  let bannerText;
  if (status.includes('open') && !status.includes('sketchonly') && !status.includes('vtuberonly')) {
    if (size === 'sm') {
      bannerText = 'Commissions open';
    } else {
      bannerText = `Commissions are currently open. ${config.slotsFilled}/${config.slotsOpen} slots filled`;
    }
  } else if (status.includes('sketchonly')) {
    if (size === 'sm') {
      bannerText = 'Sketches open';
    } else {
      bannerText = `Sketch commissions are currently open. ${config.slotsFilled}/${config.slotsOpen} slots filled`;
    }
  } else if (status.includes('vtuberonly')) {
    if (size === 'sm') {
      bannerText = 'VTuber open';
    } else {
      bannerText = `VTuber model commissions are currently open. ${config.slotsFilled}/${config.slotsOpen} slots filled`;
    }
  } else if (status === 'full') {
    if (size === 'sm') {
      bannerText = 'Slots full';
    } else {
      bannerText = `${config.slotsFilled}/${config.slotsOpen} slots filled. No requests are being taken.`;
    }
  } else {
    bannerText =
      size === 'sm'
        ? 'Commissions closed'
        : 'Commissions are currently closed. No requests are being taken.';
  }

  return (
    <BannerWrapper
      $open={status.includes('open')}
      $size={size}
      initial={theme.fadeIn.initial}
      animate={theme.fadeIn.animate}
      transition={theme.fadeIn.transition(theme.delayLg)}
    >
      <Indicator $open={status.includes('open')} />
      {bannerText}
    </BannerWrapper>
  );
};

const BannerWrapper = styled(motion.div)`
  height: fit-content;
  padding: ${props => props.theme.spaceSm};
  margin: 0 auto;
  margin-bottom: -${props => (props.$sm ? 0 : props.theme.spaceMd)};

  display: flex;
  align-items: center;
  gap: ${props => props.theme.spaceSm};

  font-size: 0.875rem;
  text-transform: uppercase;
  color: ${props => props.theme.backgroundColor};

  background-color: ${props =>
    props.$open
      ? props.theme.brand + props.theme.clear75
      : props.theme.danger + props.theme.clear75};
  backdrop-filter: blur(8px);
  border-radius: ${props => props.theme.borderFull};
`;

const Indicator = styled.span`
  width: ${props => props.theme.sizeBody};
  height: ${props => props.theme.sizeBody};
  min-width: ${props => props.theme.sizeBody};
  min-height: ${props => props.theme.sizeBody};
  display: inline-block;

  background-color: ${props => (props.$open ? props.theme.brand : props.theme.danger)};
  border-radius: ${props => props.theme.borderFull};
`;

export default Banner;
